module.exports = __webpack_public_path__ + "static/media/agenda-tres-dias-branco.ba2410d2.svg";